module.exports = __webpack_public_path__ + "img/16j030-13.b92e7ed8.png";